import React, {useEffect, useRef} from 'react'
import PropTypes from 'prop-types'
import {Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Helmet} from 'react-helmet'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const AffirmMessage = ({product, price, variantId}) => {
    const {
        app: {commerceAPI}
    } = getConfig()
    const {affirm} = commerceAPI
    const {configAffirm} = affirm || {}

    var enablePDPCallout = false
    var publicApiKey = null
    var scriptUrl = null
    var affirmMinTotal = 50.0

    try {
        const jsonConfig = JSON.parse(configAffirm)

        enablePDPCallout = jsonConfig.enablePDPCallout
        publicApiKey = jsonConfig.apiKey
        scriptUrl = jsonConfig.scriptURL
        affirmMinTotal = jsonConfig.minTotal
    } catch (e) {
        console.log(e.message)
    }

    const affirmRenderedRef = useRef(false)

    useEffect(() => {
        if (window.affirm && window.affirm.ui && window.affirm.ui.ready) {
            window.affirm.ui.ready(() => {
                window.affirm.ui.refresh()
            })
        }
    }, [price, variantId, product])

    return (
        affirmMinTotal &&
        affirmMinTotal < price &&
        enablePDPCallout && (
            <Box
                display={affirmMinTotal < price ? 'block' : 'none'}
                id={`affirm-message-${variantId}`}
                sx={{
                    '.affirm-modal-trigger': {
                        textDecoration: 'underline'
                    }
                }}
            >
                {!affirmRenderedRef.current && (
                    <>
                        <Helmet>
                            <script type="text/javascript">{`
                            var _affirm_config = { 
                                public_api_key: "${publicApiKey}",
                                script: "${scriptUrl}",
                                locale: "en_US"
                            };
                            (function(l,g,m,e,a,f,b){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,"set");d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b="set add save post open empty reset on off trigger ready setProduct".split(" ");a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=["get","token","url","items"];a<b.length;a++)d[b[a]]=function(){};h.async=!0;h.src=g[f];n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m]=c})(window,_affirm_config,"affirm","checkout","ui","script","ready");
                        `}</script>
                        </Helmet>
                        {(affirmRenderedRef.current = true)}
                    </>
                )}

                <div id="prices">
                    <Text
                        className="affirm-as-low-as"
                        data-min-total={affirmMinTotal}
                        data-page-type="product"
                        data-category={product?.c_primaryCategory}
                        data-amount={(price * 100)?.toFixed()}
                        data-affirm-color="black"
                        data-sku={variantId}
                        data-brand={product?.brand}
                    ></Text>
                </div>
            </Box>
        )
    )
}

AffirmMessage.propTypes = {
    variantId: PropTypes.string,
    product: PropTypes.any,
    price: PropTypes.any
}

export default AffirmMessage
